import React, { useContext } from "react";
import { ProductContext } from "../../../stores/session";
import request from "../../../helpers/request";
import endpoints from "../../../helpers/endpoints";

export default function useCotDate(data, setData) {
    const { apiPrefix, uuidColumn } = useContext(ProductContext)

    const updateCotDate = (date) => {
        const originalDate = data.COT_Date
        const formattedDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
        setData({
            ...data,
            COT_Date: formattedDate
        })
        request(true).post(endpoints[`${apiPrefix}_UPDATE_COT_DATE`], {
            customer: data[uuidColumn],
            date: formattedDate
        }).catch(e => {
            setData({
                ...data,
                COT_Date: originalDate
            })
            console.log(e)
            window.alert("Failed to update COT Date")
        })
    }

    return { updateCotDate }
}